import Api from '~/api'
import { resetForm, formSuccess, isLoading } from '~/form/actions'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'

export function fetchTaskTypes(projectId, interviewId, taskId, values) {
  return async dispatch => {
    try {
      let res = await Api.get('/datatable?entity=task_type&sortBy=name&sortDir=asc')
      let { data = {} } = res || {}

      if (data.success) {
        dispatch(fetchTaskTypesSuccess(data.items))
      } else {
        dispatch(fetchTaskTypesError(data.message))
      }
    } catch (err) {
      console.log(err)
      dispatch(fetchTaskTypesError(err.message || 'Error when creating project'))
    }
  }
}

export function fetchTaskTypesSuccess(items) {
  return {
    type: 'TASK_TYPE_FETCH_SUCCESS',
    items,
  }
}

export function fetchTaskTypesError(message) {
  return {
    type: 'TASK_TYPE_FETCH_ERROR',
    message,
  }
}
